import {
  Create,
  ReferenceArrayInput,
  ReferenceInput,
  SimpleForm,
  SelectInput,
  SelectArrayInput,
  SaveButton,
  Toolbar,
  useRedirect,
  useNotify,
  TimeInput,
} from 'react-admin';
import { Card, CardContent, Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { daysOfWeek, generateCronExpression } from '../../utils';
import { dataProvider } from '../../providers';
import { CustomActions } from '../../components';

const CustomToolbar = (props) => {
  const redirect = useRedirect();
  const theme = useTheme();
  const backgroundColor = theme.palette.background.paper;

  const handleCancel = () => {
    redirect('list', 'schedules');
  };

  return (
    <Toolbar
      {...props}
      sx={{
        backgroundColor,
      }}
    >
      <Box display="flex" justifyContent="flex-end" width="100%">
        <Button
          variant="text"
          onClick={handleCancel}
          sx={{
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            marginRight: theme.spacing(1),
            textTransform: 'none',
            minWidth: '95px',
          }}
          size="small"
        >
          Cancel
        </Button>
        <SaveButton
          label="Create"
          size="small"
          icon={null}
          sx={{ textTransform: 'none', minWidth: '95px' }}
        />
      </Box>
    </Toolbar>
  );
};

const CreateSchedule = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const handleCreate = async (formData) => {
    try {
      const data = {
        operator_ids: formData.operator_ids || [],
        cron_expression: generateCronExpression(formData.day_names, formData.time_name),
        route_id: formData.route_id,
      };

      await dataProvider.create('schedules', { data });

      notify('Schedule created successfully', { type: 'success' });
      redirect('list', 'schedules');
    } catch (error) {
      console.error('Error creating schedule:', error);
      notify('Error creating schedule', { type: 'error' });
    }
  };

  return (
    <Card variant="elevation" sx={{ width: '50%' }}>
      <CardContent>
        <Create actions={<CustomActions title='Add Schedule' type='create' />}>
          <SimpleForm toolbar={<CustomToolbar />} onSubmit={handleCreate}>
            <Typography variant="subtitle2">Details</Typography>
            <SelectArrayInput
              source="day_names"
              label="Select Day"
              choices={daysOfWeek}
              optionValue="id"
              optionText="name"
              fullWidth
            />
            <TimeInput source="time_name" label="Time" fullWidth />
            <ReferenceInput source="route_id" reference="routes" label="Route">
              <SelectInput optionText="name" fullWidth />
            </ReferenceInput>
            <Typography variant="subtitle2">Assign To</Typography>
            <ReferenceArrayInput source="operator_ids" reference="cognitoUsers" label="Operators">
              <SelectArrayInput optionText="name" fullWidth style={{ width: '100%' }} />
            </ReferenceArrayInput>
          </SimpleForm>
        </Create>
      </CardContent>
    </Card>
  );
};

export default CreateSchedule;
export { CreateSchedule };
